<script>
    import { onMount } from "svelte";
    import Weekday from "./Weekday.svelte";
    import { deleteField } from "firebase/firestore";

    
    export let holidays;
    // holidays = holidays ?? {};
    // holidays.periods = holidays.periods??[];

    let mode;

    onMount(() => {
        if (holidays?.length > 0) {
            mode = "differentHours";
        } else if (holidays) {
            mode = "closed";
        } else {
            mode = "regular";
        }
    })

    function handleModeChange() {
        switch (mode) {
            case "closed":
                holidays = [];
                break;
            case "regular":
                holidays = deleteField();
                break;
            case "differentHours":
                holidays = [{open: {day: 0, time: "0900"}, close: {day: 0, time: "1800"}}];
                break;
            default:
                break;
        }
    }
</script>


<select bind:value={mode} on:change={handleModeChange}>
    <option value="closed">Geschlossen</option>
    <option value="regular">Reguläre Öffnungszeiten</option>
    <option value="differentHours">Abweichende Öffnungszeiten</option>
</select>
{#if mode == "differentHours" && holidays?.length > 0}
    <Weekday day={0} name={"Feiertags"} bind:periods={holidays}/>
{/if}


<style>

</style>